import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import StuStateObj from './utils/stuState';
import ElementUI from 'element-ui';
import VueConfetti from 'vue-confetti';
import Prototype from './utils/vuePrototypes';
import Directives from './utils/directives';
import Moment from 'moment-timezone';
import 'element-ui/lib/theme-chalk/index.css';
import './utils/directive';
import Message from 'utils/OnceMessage';
import PageSpy from 'utils/pageSpy';
// if (process.env.NODE_ENV !== 'development') {
//   const Sentry = require('@sentry/browser');
//   const Integrations = require('@sentry/integrations');
//   let dsn = '';
//   switch (process.env.NODE_ENV) {
//     case 'test': {
//       dsn = 'http://3c7746c8a73e4d42a94ed88c0e1afe60@49.234.84.238/7';
//       break;
//     }
//     default: {
//       dsn = 'http://450d5dc1bde54a26932cde8c282d722c@49.234.84.238/8';
//       break;
//     }
//   }
//   Sentry.init({
//     dsn: dsn,
//     integrations: [new Integrations.Vue({ Vue, attachProps: true })]
//   });
// }
Moment.tz.setDefault('Asia/Shanghai');
const stuObj = new StuStateObj(router);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueConfetti);
Vue.prototype = Object.assign(Vue.prototype, Prototype);
Vue.prototype.$login.initCheckMpLogin();
Vue.prototype.$login.setUrlLogin();
Vue.prototype.$stuObj = stuObj;
Vue.prototype.$_stuStatusRedirect = stuObj._getStuStatusData;
Vue.prototype.$_getStuStatusData = stuObj._getStuStatusData;
Vue.prototype.$_admissionPaidRedirect = stuObj._admissionPaidRedirect;
Vue.prototype.$initStuRedirect = stuObj.initStuRedirect;
Vue.prototype.$stuStatusRedirect = stuObj.stuStatusRedirect;
Vue.prototype.$redirectToMyHsylc = stuObj.redirectToMyHsylc;
Vue.prototype.$initPaidRedirect = stuObj.initPaidRedirect;
Vue.prototype.$placeNameResult = stuObj.placeNameResult;
Vue.prototype.$stuAdmissionPaidRedirect = stuObj.stuAdmissionPaidRedirect;
Vue.prototype.$isPermitted = stuObj.isPermitted;
Vue.prototype.$_isPermitted = stuObj._isPermitted;
Vue.prototype.$minusPermission = stuObj.minusPermission;
Vue.prototype.$_minusPermission = stuObj._minusPermission;
Vue.prototype.$placeNamePermission = stuObj.placeNamePermission;
Vue.prototype.$_placeNamePermission = stuObj._placeNamePermission;
Vue.prototype.$isLimitedPaidPermission = stuObj.isLimitedPaidPermission;
Vue.prototype.$_isLimitedPaid = stuObj._isLimitedPaid;
Vue.prototype.$hsylcArena = stuObj.hsylcArenaPermission;
Vue.prototype.$hsylcStart = stuObj.isHsylcStart;
Vue.prototype.$hsylcEnd = stuObj.isHsylcEnd;
Vue.prototype.$HXWeekOfferPermission = stuObj.HXWeekOfferPermission;
Vue.prototype.$HXWeekPaidPermission = stuObj.HXWeekPaidPermission;
Vue.prototype.$hsylcFormal = stuObj.hsylcFormalPermission;
Vue.prototype.$delay = time => {
  return new Promise(resolve => setTimeout(resolve, time));
};
Vue.prototype.$getCurrentPlaceName = stuObj.getCurrentPlaceName;
Vue.prototype.$isPlaceNameFinish = stuObj.isPlaceNameFinish;
Vue.prototype.$_isPlaceNameFinish = stuObj._isPlaceNameFinish;
Vue.prototype.$message = Message;
// if (process.env.NODE_ENV === 'development' && (Vue.prototype.$isMobile || Vue.prototype.$isWeiXin)) {
//   let VConsole = require('vconsole');
//   Vue.prototype.vConsole = new VConsole();
// }
Vue.prototype.isLocal = /^localhost|172\.18\.[0-9]{1,3}\.[0-9]{1,3}/.test(window.location.host);
Vue.prototype.$gio = window.gio;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
for (let key in Directives) {
  Vue.directive(key, Directives[key]);
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
